import { AssignmentGatewayMessage } from '../../../../types/AssignmentGatewayMessage';
import { GetAssignmentsParams } from '../../../common/api/clients/gateway.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { usePaginationQuery } from '../../../common/hooks/usePaginationQuery';

export const useAssignmentsPagination = ({ page, supplierIds, customerIds }: GetAssignmentsParams) => {
    const nextPage = queries.assignments.pagination({ supplierIds, customerIds, page: page + 1 });

    return usePaginationQuery<AssignmentGatewayMessage>({
        ...queries.assignments.pagination({ supplierIds, customerIds, page }),
        prefetchQueryKey: nextPage.queryKey,
        prefetchQueryFn: nextPage.queryFn,
    });
};
